(() => {
  const root = window.Shopify?.routes?.root || '/';
  const bundleIds = [67688495448356,67688495677732,67688495710500,67688532279588];
  let busy = false, refreshing = false, timer;
  const cards = () => [...document.querySelectorAll('[data-trucast-cart-upgrade]')];
  const eligible = cart => {
    if (cart.items.some(item => bundleIds.includes(item.variant_id) || item.variant_id === 45731922903332 || item.item_components?.length || item.parent_relationship)) return null;
    return cart.items.find(item => item.variant_id === 55985886101796 && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length);
  };
  const readCart = async () => {
    const response = await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const refresh = async () => {
    if (busy || refreshing || !cards().length) return;
    refreshing = true;
    try {const line = eligible(await readCart());cards().forEach(card => {card.hidden = !line;});}
    catch {cards().forEach(card => {card.hidden = true;});}
    finally {refreshing = false;}
  };
  const schedule = () => {clearTimeout(timer);timer = setTimeout(refresh,180);};
  document.addEventListener('click',async event => {
    const button = event.target.closest('[data-trucast-upgrade-button]');
    if (!button || busy) return;
    event.preventDefault();
    busy = true;
    const card = button.closest('[data-trucast-cart-upgrade]');
    const status = card.querySelector('[data-trucast-upgrade-status]');
    const label = button.textContent;
    cards().forEach(c => {c.querySelector('button').disabled = true;});
    button.textContent = button.dataset.loading;
    status.textContent = '';
    try {
      const cart = await readCart(), line = eligible(cart);
      if (!line) {cards().forEach(c => {c.hidden = true;});return;}
      const payload = {updates:{[line.key]:0,[card.dataset.bundleVariant]:line.quantity}};
      const noteField = document.querySelector('[name="note"]');
      if (noteField) payload.note = noteField.value;
      const response = await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error('upgrade');
      window.location.assign(card.dataset.cartUrl);
    } catch {status.textContent = status.dataset.error;}
    finally {busy = false;cards().forEach(c => {c.querySelector('button').disabled = false;});button.textContent = label;}
  });
  ['cart:updated','cart:build','cart:open','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
  document.querySelectorAll('[data-products]').forEach(element => new MutationObserver(schedule).observe(element,{childList:true,subtree:true}));
  const drawer = document.getElementById('CartDrawer');
  if (drawer) new MutationObserver(schedule).observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
  window.addEventListener('pageshow',schedule);
  refresh();
})();